var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgEvaluaitLogoPayment(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 198,
    height: 34,
    viewBox: "0 0 198 34",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "evaluait logo"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M30.041 17.387V11.8191L16.8961 4.42578L3.70425 11.8191V26.6059L16.8961 33.9992L30.041 26.6059V21.9964L25.9567 24.2783L21.5907 26.7428L16.8961 29.3898L7.8355 24.2783V14.101L16.8961 8.98959L25.9567 14.101V19.6689L30.041 17.387Z",
    fill: "white"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_4"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M29.0087 17.9404L22.1546 21.8197L18.0703 24.1016V19.4921L22.1546 17.2102L26.99 14.5176L29.0087 17.9404Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M18.2607 1.63281H15.5848V8.34161H18.2607V1.63281Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_4",
    d: "M19.6937 2.73715L16.8721 -0.00585938L14.0505 2.73715L16.8721 5.48015L19.6937 2.73715Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_5"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_5",
    d: "M2.67591 22.588H0.375562C0.140832 22.588 0 22.4054 0 22.2229V15.6053C0 15.3772 0.187778 15.2402 0.375562 15.2402H2.67591V22.588Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_6",
    d: "M33.4196 22.588H31.1193V15.2402H33.4196C33.6543 15.2402 33.7952 15.4228 33.7952 15.6053V22.2229C33.7952 22.4054 33.6074 22.588 33.4196 22.588Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "EVALUAIT"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_7",
    d: "M189.659 28.2947V11.6843H192.042V28.2947H189.659ZM183.676 13.3108V11.1914H197.999V13.3108H183.676Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_8",
    d: "M173.39 28.2947V11.1914H175.773V28.2947H173.39Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_9",
    d: "M149.575 28.2947L156.775 11.1914H158.499L165.673 28.2947H163.087L157.181 13.8284H158.068L152.11 28.2947H149.575ZM152.998 24.4255V22.4047H162.251V24.4255H152.998Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_10",
    d: "M135.626 28.5412C134.324 28.5412 133.158 28.2619 132.127 27.7033C131.113 27.1282 130.311 26.3478 129.719 25.362C129.128 24.3598 128.832 23.2262 128.832 21.9611V11.1914H131.215V21.9118C131.215 22.8154 131.409 23.5958 131.798 24.253C132.187 24.9102 132.71 25.4195 133.37 25.781C134.046 26.1424 134.798 26.3232 135.626 26.3232C136.488 26.3232 137.24 26.1424 137.882 25.781C138.541 25.4195 139.057 24.9102 139.428 24.253C139.817 23.5958 140.012 22.8236 140.012 21.9364V11.1914H142.42V21.9857C142.42 23.2508 142.124 24.3762 141.533 25.362C140.941 26.3478 140.138 27.1282 139.124 27.7033C138.11 28.2619 136.944 28.5412 135.626 28.5412Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_11",
    d: "M110.594 28.2947V11.1914H112.977V28.2947H110.594ZM112.216 28.2947V26.1753H121.647V28.2947H112.216Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_12",
    d: "M86.7803 28.2947L93.9799 11.1914H95.7038L102.878 28.2947H100.292L94.3855 13.8284H95.2728L89.3154 28.2947H86.7803ZM90.2026 24.4255V22.4047H99.4557V24.4255H90.2026Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_13",
    d: "M73.7104 28.2947L66.6629 11.1914H69.2487L75.054 25.6578H74.1161L79.9721 11.1914H82.5325L75.4343 28.2947H73.7104Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_14",
    d: "M48.2744 28.2947V11.1914H50.6574V28.2947H48.2744ZM49.8969 28.2947V26.1753H59.9865V28.2947H49.8969ZM49.8969 20.5563V18.5355H59.1499V20.5563H49.8969ZM49.8969 13.3108V11.1914H59.8598V13.3108H49.8969Z",
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEvaluaitLogoPayment);
export default __webpack_public_path__ + "static/media/evaluait-logo-payment.0ad1237e634a82931b6617e8798467c5.svg";
export { ForwardRef as ReactComponent };